import { render, staticRenderFns } from "./AffiliateTransactionsPage.vue?vue&type=template&id=392b5c4b&scoped=true&lang=pug&"
import script from "./AffiliateTransactionsPage.vue?vue&type=script&lang=js&"
export * from "./AffiliateTransactionsPage.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateTransactionsPage.vue?vue&type=style&index=0&id=392b5c4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392b5c4b",
  null
  
)

export default component.exports